// The SVG each tool starts with. Small, but it has what the tools handle: a gradient that is
// referenced by id, a <use> with xlink:href, an inline style, a class and a comment.
export const SAMPLE = {
  name: 'moon-badge.svg',
  text: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="120" height="120" viewBox="0 0 120 120">
  <!-- A sample with a gradient, ids, inline styles and xlink:href -->
  <defs>
    <linearGradient id="sky" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0" stop-color="#5BB8FF"/>
      <stop offset="1" stop-color="#2E6BFF"/>
    </linearGradient>
    <path id="moon" d="M54.6 28A34 34 0 1 0 88.2 72.8 28 28 0 0 1 54.6 28z"/>
  </defs>
  <rect width="120" height="120" rx="28" fill="url(#sky)"/>
  <use xlink:href="#moon" fill="#ffffff" fill-opacity="0.95"/>
  <circle cx="84" cy="30" r="4" style="fill: #ffffff; opacity: 0.85"/>
  <circle class="star" cx="98" cy="50" r="2.5" fill="#ffffff"/>
</svg>
`,
};
